"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v16Upgrade = exports.v16Downgrade = void 0;
const v16Downgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, variants, trigger, published, frequency, referrerTargets, id, integrations, event, version, parentVersion, meta, urlTargets, cookieTargets, geoTargets, scheduling, } = rule;
    const maxWeightVariant = variants.reduce((maxWeightVariant, variant) => !maxWeightVariant || variant.weight > maxWeightVariant.weight ? variant : maxWeightVariant, null);
    return {
        schemaVersion: 15,
        ubCode,
        clientUuid,
        embUuid,
        variants: variants.map((variant) => ({
            // Discard dimensions and display
            letter: variant.letter,
            trackingId: variant.trackingId,
            weight: variant.weight,
        })),
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations,
        event,
        version,
        parentVersion,
        dimensions: maxWeightVariant
            ? maxWeightVariant.dimensions
            : {
                desktopEnabled: null,
                mobileEnabled: null,
                desktop: { width: 0, height: 0 },
                mobile: { width: 0, height: 0 },
            },
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
        displaySettings: maxWeightVariant ? maxWeightVariant.display : { name: 'overlay' },
    };
};
exports.v16Downgrade = v16Downgrade;
const v16Upgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, variants, trigger, published, frequency, referrerTargets, id, integrations, event, version, parentVersion, dimensions, meta, urlTargets, cookieTargets, geoTargets, scheduling, displaySettings, } = rule;
    return {
        schemaVersion: 16,
        ubCode,
        clientUuid,
        embUuid,
        variants: variants.map((variant) => ({
            letter: variant.letter,
            trackingId: variant.trackingId,
            weight: variant.weight,
            dimensions,
            display: displaySettings,
        })),
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations,
        event,
        version,
        parentVersion,
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
    };
};
exports.v16Upgrade = v16Upgrade;
//# sourceMappingURL=v16.js.map